export const costCalculatorData = {
  // 每坪基礎單價 (萬元/坪)
  methodPrices: {
    rc: { min: 15, max: 25, name: "傳統 RC 工法", desc: "傳統鋼筋混凝土，成本較低但工期較長" },
    src: { min: 20, max: 30, name: "傳統 SRC 工法", desc: "鋼骨鋼筋混凝土，結構強度較高" },
    steel: { min: 25, max: 40, name: "預製鋼構工法", desc: "Chronos 主推，工廠預製 + 現場組裝，工期縮短 50%" },
    hybrid: { min: 22, max: 35, name: "混合工法", desc: "結合多種結構系統，彈性較高" },
  },

  // 樓層加成係數
  floorMultipliers: {
    1: 1.0,
    2: 1.05,
    3: 1.12,
    4: 1.2,
  },

  // 坪數選項
  areaOptions: [30, 50, 80, 100, 120, 150, 200],

  // 樓層選項
  floorOptions: [1, 2, 3, 4],
};